import authMixin from "@/mixins/authMixin";
import dialogMixin from "@/mixins/dialogMixin";
import machineMixin from "@/mixins/machineMixin";
import pageMixin from "@/mixins/pageMixin";

export default {
  mixins: [authMixin, dialogMixin, machineMixin, pageMixin],
  computed: {
  },
  methods: {
  },
};
